import React, { useEffect, useState } from "react";
import { BsDot, BsDownload } from "react-icons/bs";
import ImageGallery from "react-image-gallery";
import Shipped from "../../assets/img/shipped.png";
import GuaranteeCertificate from "../../assets/img/guarantee-certificate.png";
import CustomerService from "../../assets/img/customer-service.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import axiosClient from "../../api";
import { RiArrowGoBackFill } from "react-icons/ri";

const ProductDetail = () => {
  const [data, setData] = useState({});
  const [file, setFile] = useState([]);
  const [selectedTab, setSelectedTab] = useState("description");

  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    axiosClient
      .get(`/Product/GetByPermalink?Permalink=${params.id}`)
      .then((res) => {
        setData(res.data.product);
      });
  }, [params.id]);

  useEffect(() => {
    if (data?.id) {
      getFileById(data.id);
    }
  }, [data?.id]);

  const getFileById = (id) => {
    axiosClient.get(`/ProductFile?ProductId=${id}`).then((res) => {
      setFile(res?.data?.productFile);
      console.log(res?.data?.productFile);
    });
  };

  return (
    <div className="bg-[#1218200d] pb-20">
      <div className="container">
        <div className="flex items-center flex-wrap py-5">
          <p className="text-black text-lg font-semibold">
            <Link to="/">Ana Sayfa</Link>
          </p>
          <p className="text-black text-lg font-semibold">
            <BsDot size={22} />
          </p>
          <p className="text-black text-lg font-semibold">
            <Link to="/urunler">Ürünler</Link>
          </p>
          <p className="text-black text-lg font-semibold">
            <BsDot size={22} />
          </p>
          <p className="text-black text-lg font-semibold">{data?.name}</p>
        </div>
        <div className="bg-white rounded-sm py-10 relative">
          <Link to="/urunler">
            <RiArrowGoBackFill
              size={30}
              className="absolute right-5 top-5 text-main"
            />
          </Link>
          <div className="flex flex-col md:flex-row">
            <div className="flex-1 flex justify-center items-center px-10 h-fit">
              <ImageGallery
                showPlayButton={false}
                disableKeyDown={false}
                showNav={false}
                additionalClass="w-1/2"
                items={
                  data?.photos?.map((photo) => ({
                    original: `https://cdn.lensa.com.tr/${photo?.photoUrl}`,
                    thumbnail: `https://cdn.lensa.com.tr/${photo?.photoUrl}`,
                  })) || []
                }
              />
            </div>
            <div className="flex-1 px-5 relative">
              <p className="text-md text-gray-500 font-semibold">
                {data?.brand?.name}
              </p>
              <h1 className="text-4xl font-semibold">{data?.name}</h1>

              <table className="border-collapse w-full mt-3">
                <tbody>
                  {data?.productAttribute?.map((item) => {
                    if (item.attributeName === "") {
                      return null;
                    }
                    return (
                      <tr className="border-b">
                        <th className="py-2 text-left">
                          {item?.attributeName}
                        </th>
                        <td className="py-2 px-4">
                          {item?.attributeDescription}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div className="mt-10 flex items-center justify-between max-md:flex-col max-md:items-start">
                <div
                  className="bg-main py-2 px-4 text-white font-medium cursor-pointer max-md:mb-10"
                  onClick={() => {
                    navigate("/iletisim", {
                      state: { name: data?.name, productId: data?.id },
                    });
                  }}
                >
                  <span>İletişime Geç</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-sm px-10 py-5 mt-10 flex items-center max-md:flex-col max-md:gap-10 max-md:items-start">
          <div className="flex-1 max-md:flex max-md:items-start max-md:gap-1 max-md:flex-col">
            <p className="font-semibold text-3xl max-md:text-base">
              Stok kodu: {data?.stockCode || "-"}
            </p>
            <p className="mt-4 max-md:mt-0 text-lg">
              <span className="font-semibold text-xl max-md:text-base">
                Kategoriler:
              </span>{" "}
              {data?.productAttribute?.map((item) => {
                if (item.attributeName === "Kategoriler") {
                  return item.attributeDescription;
                }
                return null; // Add a return statement here
              })}
            </p>
            <p className="text-lg">
              <span className="font-semibold text-xl max-md:text-base">
                Marka:{" "}
              </span>
              {data?.brand?.name}
            </p>
          </div>
          <div className="flex-1 flex justify-between max-md:gap-5">
            <div className="flex justify-center flex-col items-center gap-2">
              <img src={Shipped} className="w-14" alt="" />
              <p className="font-bold">1-4 GÜN TESLİMAT</p>
            </div>
            <div className="flex justify-center flex-col items-center gap-2">
              <img src={GuaranteeCertificate} className="w-14" alt="" />
              <p className="font-bold">%100 ORİJİNAL VE KALİTE</p>
            </div>
            <div className="flex justify-center flex-col items-center gap-2">
              <img src={CustomerService} className="w-14" alt="" />
              <p className="font-bold">MÜŞTERİ HİZMETLERİ</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-sm px-10 py-5 mt-10">
          <div className="flex items-center gap-4">
            <p
              onClick={() => setSelectedTab("description")}
              className={`text-3xl font-semibold cursor-pointer ${
                selectedTab === "description" ? "border-b-2 border-black" : ""
              }`}
            >
              Açıklama
            </p>
            <p
              onClick={() => {
                setSelectedTab("file");
                getFileById(data?.id);
              }}
              className={`text-3xl font-semibold cursor-pointer ${
                selectedTab === "file" ? "border-b-2 border-black" : ""
              }`}
            >
              Dosya
            </p>
          </div>
          <div className="mt-6">
            {
              {
                description: (
                  <div
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                  />
                ),
                file: (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200">
                      <thead>
                        <tr>
                          <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Dosya Adı
                          </th>
                          <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            Dosya Açıklaması
                          </th>
                          <th className="px-6 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                            İndir
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {file.map((item) => (
                          <tr>
                            <td className="px-6 py-4 border-b border-gray-200">
                              {item?.name}
                            </td>
                            <td className="px-6 py-4 border-b border-gray-200">
                              {item?.description}
                            </td>
                            <td className="px-6 py-4 border-b border-gray-200">
                              <a
                                href={`https://cdn.lensa.com.tr/${item?.media?.photoUrl}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <BsDownload size={25} />
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ),
              }[selectedTab]
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
